import { filterOptions } from '@/utils/query-base'

const be = filterOptions(['EQ'])
const city = filterOptions(['EQ', 'EMPTY', 'NEMPTY', 'NE'])
const all = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'BT', 'GT', 'LT', 'LE', 'GE'])
const cusname = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'CP-S'])

export default {
  'sal_center': {
    describe: true,
    title: '营销单元',
    type: 'select',
    equation: all,
    dictionary: 'sale'
  },
  'zzfld00003e': {
    describe: true,
    title: '基地',
    type: 'select',
    equation: all,
    dictionary: 'base'
  },
  'sales_emp_name': {
    title: '业务员',
    type: 'input',
    equation: all
  },
  'cntrno': {
    title: '合同单号',
    type: 'input',
    equation: all,
    slot: true
  },
  'cnrtln': {
    title: '合同编号',
    type: 'input',
    equation: all
  },
  'cntrname': {
    describe: true,
    title: '合同名称',
    type: 'select',
    equation: city,
    dictionary: 'A0051'
  },
  'customer': {
    title: '客户编号',
    type: 'dialog',
    equation: all,
    dialog: {
      component: 'ClientSelect',
      title: '客户编号'
    }
  },
  'name1': {
    title: '客户名称',
    type: 'input',
    equation: cusname
  },
  'customer_type': {
    describe: true,
    title: '客户类型',
    type: 'select',
    equation: city,
    dictionary: 'A0009'
  },
  'contr_year': {
    title: '合同年度',
    type: 'year',
    equation: city
  },
  'cotr_qty': {
    title: '合同数量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'cotr_amt': {
    title: '合同金额',
    xlsxFmt: {
      t: 'n'
    }
  },
  'cotr_start': {
    title: '开始日期',
    type: 'date',
    equation: all
  },
  'cont_end': {
    title: '结束日期',
    type: 'date',
    equation: all
  },
  'cont_close': {
    title: '终止日期',
    type: 'date',
    equation: all
  },
  'stacode': {
    describe: true,
    title: '合同状态',
    type: 'select',
    equation: city,
    dictionary: 'A0048'
  },
  'wly201': {
    title: '五粮液.经典(鼓型瓶)'
  },
  'wlyxp': {
    title: '五粮液.新品'
  },
  'wly1618': {
    title: '五粮液.1618'
  },
  'wlyd39': {
    title: '五粮液.低度(39%)'
  },
  'wlyd42': {
    title: '五粮液.低度(42%)'
  },
  'zmdzs': {
    title: '专卖店专属产品'
  },
  'tsggwly': {
    title: '特殊规格五粮液'
  },
  'tsgg1618': {
    title: '特殊规格1618'
  },
  'wlyjd': {
    title: '五粮液.经典'
  },
  'tglsqd': {
    title: '团购渠道'
  },
  'mymjqd': {
    title: '名烟名酒渠道'
  },
  'cyqd': {
    title: '餐饮渠道'
  },
  'kaqd': {
    title: 'ka渠道'
  },
  'dsqd': {
    title: '电商（新零售）渠道'
  },
  'zmdqd': {
    title: '专卖店渠道'
  },
  'zymdqd': {
    title: '自营门店渠道'
  },
  'qyxscqd': {
    title: '区域性商超渠道'
  },
  'market': {
    describe: true,
    title: '卖场',
    type: 'select',
    equation: city,
    dictionary: 'A0052'
  },
  'market_quan': {
    title: '门店数量',
    xlsxFmt: {
      t: 'n'
    }
  },
  'name_first': {
    title: '创建人',
    type: 'input',
    equation: cusname
  },
  'datum': {
    title: '创建日期',
    type: 'date',
    equation: all
  },
  'region': {
    title: '省',
    type: 'select',
    describe: true,
    equation: be,
    dictionary: 'region'
  },
  'city_code': {
    title: '市',
    type: 'select',
    describe: true,
    equation: city,
    dictionary: 'city'
  },
  'street': {
    title: '区',
    type: 'select',
    describe: true,
    equation: city,
    dictionary: 'street'
  },
  'address': {
    title: '收货地址',
    type: 'input',
    equation: all
  },
  'approval_no': {
    title: '签约审批单号',
    type: 'input',
    equation: all
  },
}



// WEBPACK FOOTER //
// ./src/views/contract-manage/config/contractDetailReport.js